import dayjs from "dayjs";
import React from "react";
import { useSelector } from "react-redux";
import TaskIcon from "@mui/icons-material/Task";
import bookclosuretablecss from "../../myfin_v2/css/bookclosuretable.module.css";
import StatusIndicator from "../../myfin_v2/elements/StatusIndicator";
import { ReactComponent as CircleCheckIcon } from "../../myfin_v2/assets/icons/circle_check.svg";

const BookClosureConnectedTasks = ({ ViewTaskMore, connectedTasks,parentTaskId }) => {
  return (
    <>
      <div
        className={bookclosuretablecss.bookClosureTableContainer}
        style={{ "border-radius": "0px" }}
      >
        <table className={bookclosuretablecss.bookClosureTable}>
          <thead>
            <th className="text-left">Task Name</th>
            <th className="text-left">Module</th>
            <th className="text-left">Assignee</th>
            <th className="text-left">Approver</th>
            <th className="text-left">Due Date</th>
            <th className="text-left">Status</th>
            <th></th>
          </thead>
          <tbody>
            {connectedTasks && connectedTasks.length > 0 ? (
              connectedTasks.map((task, index) => (
                <React.Fragment key={index}>
                  <tr key={index} onClick={() => {if(!task.isConfidential){ViewTaskMore(task._id,task.reviewed,parentTaskId)}}}>
                    <td style={{ color: "#277154" }}>{task?.name}</td>
                    <td style={{"text-transform": "uppercase","font-weight":"600"}}>{task?.module}</td>
                    <td>
                      {task.assigneeData
                        .map((assign) => assign?.name)
                        .join(", ")}
                    </td>
                    <td>{task.approverData?.name}</td>
                    <td>
                      {task?.dueDate
                        ? dayjs(task?.dueDate).format("DD-MMM-YYYY")
                        : ""}
                    </td>
                    <td>
                      {" "}
                      <StatusIndicator status={task.status} />
                    </td>
                    <td>{task.reviewed && <CircleCheckIcon />}</td>
                  </tr>
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td
                  colSpan={6}
                  className="text-secondary text-center font-size-16 custom-font-600 font-inter"
                >
                  {" "}
                  No Connected Tasks
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default BookClosureConnectedTasks;
